import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import NewReceipt from "@/pages/NewReceipt";
import ReceiptRegister from "@/pages/ReceiptRegister";
import ReceiptView from "@/pages/ReceiptView";
import DepositToBank from "@/pages/DepositToBank";
import OwnerHandover from "@/pages/OwnerHandover";
import CashLedger from "@/pages/CashLedger";
import Reports from "@/pages/Reports";
import UserManagement from "@/pages/UserManagement";
import Settings from "@/pages/Settings";
import { Toaster } from "@/components/ui/sonner";

function Guarded({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <Guarded>
                <AppLayout />
              </Guarded>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/new-receipt" element={<NewReceipt />} />
            <Route path="/receipts" element={<ReceiptRegister />} />
            <Route path="/receipts/:id" element={<ReceiptView />} />
            <Route path="/deposit" element={<DepositToBank />} />
            <Route path="/handover" element={<OwnerHandover />} />
            <Route path="/ledger" element={<CashLedger />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/users" element={<AdminOnly><UserManagement /></AdminOnly>} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
